import http from "./http-common";
  
const GetProfileByIdRespondent = idRespondent => {
    return http.get(`/respondents/${idRespondent}/profiles`); 
}

const GetSurveyByRespondent =  (idRespondent , idSurvey) =>  {
    return http.get(`/respondents/${idRespondent}/surveys/${idSurvey}`); 
} 

const GetListSurveyByRespondentId = idRespondent  => {
    return http.get(`/respondents/${idRespondent}/surveysrespondents`);      
}

const GetSurveyBySurveyIdRespondentId = (idRespondent , idSurvey) => {
    return http.get(`/respondents/${idRespondent}/surveys/${idSurvey}`);      
} 

const GetSurveyByPublicCodeAndSurveyId = (idSurvey , codepublic) => {
    return http.get(`/respondents/${idSurvey}/surveypublic/${codepublic}`);      
} 

const PutSurveyRespondent = (idRespondent , idSurvey , bodySurvey) => {
    return http.put(`/respondents/${idRespondent}/surveys/${idSurvey}` , bodySurvey )
}

const PutProfileRespondent = (idRespondent , idProfile , bodyProfile) => {
    return http.put(`/respondents/${idRespondent}/profiles/${idProfile}` , bodyProfile )
}

const PostProfile = (idRespondent , bodyProfile) => {
    return http.post(`/respondents/${idRespondent}/profiles` , bodyProfile )
}

const PostAnswerRespondent = (idRespondentpost , idSurveyResponsepost , privateCode ,  bodyProfile) => {
    return http.post(`/respondents/${idRespondentpost}/answerprivate/${idSurveyResponsepost}/${privateCode}` , bodyProfile )
} 

const PostAnswerRespondentPublic = (idSurvey, codepublic , bodyAnswer ) => {
    return http.post(`/respondents/answerpublic/${idSurvey}/${codepublic}` , bodyAnswer ) 
}

const PostOtpAnswerRespondentImported = (idSurvey , bodyAnswerRespondent ) => {
    return http.post(`/respondents/answerimportedotp/${idSurvey}` , bodyAnswerRespondent )
}

const PostImportProfile = (id, email, cod) => {
    return http.post(`/respondents/${id}/profile${!cod ? '-pre-' : '-'}import/${cod ? cod + '/' : ''}${email}`)
};

const RespondentService = {
    GetProfileByIdRespondent,
    GetSurveyByRespondent,
    GetListSurveyByRespondentId,
    GetSurveyBySurveyIdRespondentId, 
    GetSurveyByPublicCodeAndSurveyId,
    PutSurveyRespondent,
    PutProfileRespondent,
    PostProfile,
    PostAnswerRespondent,
    PostAnswerRespondentPublic,
    PostOtpAnswerRespondentImported,
    PostImportProfile
};

export default RespondentService;
